/**
 * Service worker registration for Nail Viet Club PWA.
 *
 * Registers /service-worker.js on production builds and prompts users to
 * refresh when a new version is available.
 */
const isLocalhost = Boolean(
  typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "[::1]" ||
      /^127(?:\.\d+){3}$/.test(window.location.hostname))
);

export function register() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  // Only register over secure origins (PWAs require HTTPS, localhost is exempt).
  const isSecure = window.location.protocol === "https:" || isLocalhost;
  if (!isSecure) return;

  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/service-worker.js");
      reg.onupdatefound = () => {
        const installing = reg.installing;
        if (!installing) return;
        installing.onstatechange = () => {
          if (installing.state === "installed" && navigator.serviceWorker.controller) {
            // New SW available — caller can show a toast or auto-reload.
            console.info("Nail Viet Club: new version available — refresh to update.");
          }
        };
      };
    } catch (e) {
      console.warn("SW registration failed", e);
    }
  });
}

export function unregister() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  navigator.serviceWorker.ready.then((reg) => reg.unregister()).catch(() => { /* ignore */ });
}
